// crm-web/frontend/src/components/shared/ScarBadge.jsx
// Cicatriz de descuido: badge a la derecha del IC. 4 estados:
//   red       = descuidado ahora (♻️ rojo)
//   green     = rescatado tras descuido (♻️ verde)
//   tombstone = cayo en Atrasados (vencido ≥2 dias) sin haber sido rojo (🪦)
//   zombie    = lapida revivida (reagendada con nota humana) (🧟)
// Posicion ABSOLUTA al borde derecho de la celda IC (el padre <td> debe ser relative).
const RECYCLE = (
  <svg viewBox="0 0 24 24" className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5" />
    <path d="M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12" />
    <path d="m14 16-3 3 3 3" />
    <path d="M8.293 13.596 7.196 9.5 3.1 10.598" />
    <path d="m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843" />
    <path d="m13.378 9.633 4.096 1.098 1.097-4.096" />
  </svg>
)

const CONFIG = {
  red:       { color: 'text-red-600 dark:text-red-500',   title: 'Descuidado: agendado sin gestión hace ≥2 días hábiles', node: RECYCLE },
  green:     { color: 'text-green-600 dark:text-green-500', title: 'Rescatado tras descuido', node: RECYCLE },
  tombstone: { color: '', title: 'Lápida: cayó en Atrasados (vencido ≥2 días) sin gestión', node: <span className="text-[13px] leading-none">🪦</span> },
  zombie:    { color: '', title: 'Zombie: muerto revivido (reagendado con nota)', node: <span className="text-[13px] leading-none">🧟</span> },
}

export default function ScarBadge({ level }) {
  const cfg = CONFIG[level]
  if (!cfg) return null
  return (
    <span title={cfg.title} className={`absolute right-0.5 top-1/2 -translate-y-1/2 pointer-events-none ${cfg.color}`} aria-label={`cicatriz ${level}`}>
      {cfg.node}
    </span>
  )
}
